import { getApiErrorMessage } from './apiErrorHandler';

export const handleApiRequest = async ({
  requestFn,
  onSuccess,
  onError,
  finallyFn,
  showError,
  setError,
}) => {
  try {
    const res = await requestFn();

    onSuccess?.(res);

    return {
      success: true,
      data: res,
    };
  } catch (error) {
    const message = getApiErrorMessage(error);

    setError?.(message);
    showError?.(message);
    onError?.(message);

    return {
      success: false,
      error: message,
    };
  } finally {
    finallyFn?.();
  }
};
